import { detectAvif, detectWebP } from "../../ceres/helper/featureDetect";

const validConversionExtensions = ["jpg", "JPG", "jpeg", "JPEG", "png", "PNG", "webp"];
const avifExtension = "avif";
const webpExtension = "webp";
const imgRegex = /.?(\.\w+)(?:$|\?)/;

export const ImageConverterMixin = {
    props: {
        convertImage: {
            type: Boolean,
            default: true
        }
    },

	data() {
		return {
			imageConversionEnabled: App.config.log.modernImagesConversion,
			browserSupportedImgExtension: null,
			avifSupported: false,
			webpSupported: false
		};
	},

	mounted() {
		detectAvif(((avifSupported) => {
            this.avifSupported = avifSupported;

            if (avifSupported) {
                this.setBrowserSupportedImageExt();
            }

            if (!avifSupported) {
                detectWebP(((webpSupported) => {
                    this.webpSupported = webpSupported;

                    if (webpSupported) {
                        this.setBrowserSupportedImageExt();
                    }
                }));
            }
        }));
	},

	methods: {
		convertFormat(url) {
			const matches = url?.match(imgRegex);

			if (matches) {
				const receivedImageExtension = matches[1].split(".").pop();
				const shouldConvert = this.convertImage &&
						this.imageConversionEnabled &&
						/\/item\/images\//.test(url) &&
						this.browserSupportedImgExtension !== receivedImageExtension &&
						validConversionExtensions.includes(receivedImageExtension);
                const selectedExtension = this.browserSupportedImgExtension === null ? "avif" : this.browserSupportedImgExtension;

				return shouldConvert ?
					`${url}.${selectedExtension}` :
					url;
			}

			return url;
		},

		setBrowserSupportedImageExt() {
            if (this.avifSupported) {
                this.browserSupportedImgExtension = avifExtension;
                return;
            }

            if (this.webpSupported) {
                this.browserSupportedImgExtension = webpExtension;
                return;
            }

            this.browserSupportedImgExtension = this.receivedImageExtension !== avifExtension && this.receivedImageExtension !== webpExtension
                ? this.receivedImageExtension
                : "jpeg";
        }
	}
};
